import { cn } from "@newxsystems/shared";
import { DaylightCommonContent } from "../../../../modules/content/components/DaylightCommonContent/DaylightCommonContent";
import { DaylightRichText } from "../../../../modules/content/components/DaylightRichText/DaylightRichText";
import { DaylightSection } from "../../../../modules/content/components/DaylightSection/DaylightSection";
import type { IStatsBlockProps } from "./StatsBlock.props";

const columns = {
  1: "grid-cols-1",
  2: "grid-cols-1 sm:grid-cols-2",
  3: "grid-cols-1 sm:grid-cols-2 md:grid-cols-3",
  4: "grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4",
} as const;

export const StatsBlock = ({
  alignment,
  anchorId,
  buttons,
  columnCount,
  description,
  eyebrow,
  heading,
  items,
  parentClass,
  spacing,
}: IStatsBlockProps) => {
  if (!items?.length) return null;

  return (
    <DaylightSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="daylight-work-surface overflow-hidden rounded-[28px] p-7 md:p-12 lg:p-16">
        <DaylightCommonContent
          alignment={alignment}
          buttons={buttons}
          description={description}
          eyebrow={eyebrow}
          heading={heading}
        />
        <div
          className={cn("mt-12 grid border-t border-cobalt/30 md:mt-16", columns[columnCount || 3])}
        >
          {items.map((item, index) => (
            <article
              className="border-b border-cobalt/30 py-8 sm:px-6 sm:first:pl-0 sm:last:pr-0"
              key={index}
            >
              <p className="font-daylight-display text-5xl font-semibold leading-none tracking-[-0.03em] text-cobalt md:text-6xl">
                {item.value}
              </p>
              <h3 className="mt-5 font-daylight-body text-sm font-semibold text-foreground">
                {item.label}
              </h3>
              {item.description ? (
                <DaylightRichText
                  className="mt-3 max-w-[32ch] text-base text-basalt md:text-lg"
                  content={item.description}
                />
              ) : null}
            </article>
          ))}
        </div>
      </div>
    </DaylightSection>
  );
};

StatsBlock.displayName = "Block::StatsBlock";
